module.exports = __webpack_public_path__ + "img/lianhuadeng1.139c2e3f.png";